import React, { useEffect } from 'react';
import { SuccessMessageContainer } from './SuccessMessage.styles';
import { AllieButton, AllieImg, AllieText } from '../../../components';

interface AllieSuccessMessageProps {
  onContinue?: () => void;
  continueButtonText?: string;
  title: string;
  descriptionLine1?: string;
  descriptionLine2?: string;
  isMobile?: boolean;
  timeout?: number;
}

const namespace = 'success-message';

export const AllieSuccessMessage: React.FC<AllieSuccessMessageProps> = ({
  onContinue,
  continueButtonText,
  title,
  descriptionLine1,
  descriptionLine2,
  isMobile,
  timeout,
}) => {
  useEffect(() => {
    if (timeout) {
      setTimeout(() => {
        onContinue?.();
      }, timeout)
    }
  }, []);

  return (
    <SuccessMessageContainer isMobile={isMobile}>
      <AllieText type="h3">{title}</AllieText>
      <div className={`${namespace}-gif`}>
        <AllieImg src="assets/change-password-success.gif" />
      </div>
      <div className={`${namespace}-body`}>
        {descriptionLine1 && (
          <AllieText type="h4" color="neutral-50" weight={600}>
            {descriptionLine1}
          </AllieText>
        )}
        {descriptionLine2&& (
          <AllieText type="body1" color="neutral-50">
            {descriptionLine2}
          </AllieText>
        )}
      </div>
      {(!timeout || continueButtonText) && (
        <div className={`${namespace}-confirm`}>
          <AllieButton
            onClick={onContinue}
            corner="rounded-edges"
            allieColor="primary"
            allieSize="small"
          >
            {continueButtonText || 'OK'}
          </AllieButton>
        </div>
      )}
    </SuccessMessageContainer>
  );
};
